module.exports = __webpack_public_path__ + "static/media/stock_Exchange_Rules.0939a4f9.pdf";